import { render, staticRenderFns } from "./PackingListComponent.vue?vue&type=template&id=0f675035&scoped=true&"
import script from "./PackingListComponent.vue?vue&type=script&lang=js&"
export * from "./PackingListComponent.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=0f675035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f675035",
  null
  
)

export default component.exports